// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function InputWithPrefix$LoadingSpinner(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Spinner.make, {}),
              className: "h-21 w-21 flex items-center justify-center"
            });
}

var LoadingSpinner = {
  make: InputWithPrefix$LoadingSpinner
};

function InputWithPrefix(props) {
  var status = props.status;
  var borderColor = status !== undefined ? (
      status === "error" ? "border-tan-error-500" : (
          status === "ok" ? "border-tan-success" : "border-zinc-200"
        )
    ) : "border-zinc-200";
  var inputRef = React.useRef(null);
  var onClick = React.useCallback((function (param) {
          Core__Option.forEach(Caml_option.nullable_to_opt(inputRef.current), (function (el) {
                  el.focus();
                }));
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.prefix,
                      className: "text-zinc-500 cursor-default"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              ref: Caml_option.some(function (i) {
                                    inputRef.current = i;
                                  }),
                              className: "text-zinc-800 flex-grow min-w-0",
                              spellCheck: false,
                              value: props.value,
                              onBlur: props.onBlur,
                              onChange: props.onChange
                            }),
                        status === "validating" ? JsxRuntime.jsx(InputWithPrefix$LoadingSpinner, {}) : null
                      ],
                      className: "flex items-center min-w-0 gap-1 flex-grow"
                    })
              ],
              className: TailwindMerge.twMerge([
                    borderColor,
                    "flex flex-col lg:flex-row border rounded-md px-3 py-2 gap-x-1 gap-y-2 [&:has(input:focus)]:border-zinc-300"
                  ]),
              onClick: onClick
            });
}

var make = InputWithPrefix;

exports.LoadingSpinner = LoadingSpinner;
exports.make = make;
/* react Not a pure module */
